// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const FORMAT_OTHER = "other";
export const DEVICE_FAMILY_NONE = "";
export const ORGANIZATION_NONE = "";
